
const browserHelper = {
    ///获取浏览器信息
    getBrowserInfo: function () {
        // 浏览器窗口宽高
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

        // 用户代理字符串
        const userAgent = navigator.userAgent || '';

        // 浏览器名称
        let browserName = "Unknown";
        if (userAgent.indexOf("Firefox") > -1) {
            browserName = "Firefox";
        } else if (userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Edg") === -1) {
            browserName = "Chrome";
        } else if (userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") === -1) {
            browserName = "Safari";
        } else if (userAgent.indexOf("Edg") > -1) {
            browserName = "Edge";
        } else if (userAgent.indexOf("Trident") > -1) {
            browserName = "Internet Explorer";
        }

        // 操作系统信息
        let os = "Unknown";
        if (userAgent.indexOf("Win") !== -1) os = "Windows";
        else if (userAgent.indexOf("Mac") !== -1) os = "MacOS";
        else if (userAgent.indexOf("Linux") !== -1) os = "Linux";
        else if (userAgent.indexOf("Android") !== -1) os = "Android";
        else if (userAgent.indexOf("like Mac") !== -1) os = "iOS";

        // 用|分割返回
        return `WindowSize:${width}x${height}|Browser:${browserName}|OS:${os}`;
    }
}

export default browserHelper;